<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div>
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="importClick"
            :disabled="projectDetail.is_synchro_edc"
            v-permission="['单位管理导入单位']"
            >导入单位</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            :disabled="projectDetail.is_synchro_edc"
            v-permission="['单位管理新增单位']"
            @click="createUnit"
            >创建单位</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        stripe
        v-loading="loading"
        size="mini"
        :data="unitData"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        border
        :cell-style="cellStyle"
      >
        <el-table-column prop="code" label="单位编号"> </el-table-column>
        <el-table-column
          prop="style"
          label="单位类型"
          column-key="style"
          sortable
          filter-placement="bottom-end"
        >
        </el-table-column>
        <el-table-column prop="name" label="单位名称" width="391">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="200" sortable>
          <template slot-scope="scope">
            <span
              v-if="scope.row.enable"
              type="text"
              size="mini"
              style="font-size: 12px; color: #52c41a"
              >已启用</span
            >
            <span
              v-if="!scope.row.enable"
              type="text"
              size="mini"
              style="font-size: 12px; color: #bfbfbf"
              >已禁用</span
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              v-permission="['单位管理编辑单位']"
              :disabled="projectDetail.is_synchro_edc"
              @click="editClick(scope.row)"
              >编辑</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              v-permission="['单位管理删除单位']"
              :disabled="projectDetail.is_synchro_edc"
              @click="deleteClick(scope.row)"
              >删除</el-link
            >
            <el-link
              v-if="scope.row.enable"
              type="primary"
              :underline="false"
              style="font-size: 12px"
              v-permission="['单位管理禁用单位']"
              :disabled="projectDetail.is_synchro_edc"
              @click="disableClick(scope.row)"
              >禁用</el-link
            >
            <el-link
              v-if="!scope.row.enable"
              type="primary"
              :underline="false"
              style="font-size: 12px"
              v-permission="['单位管理禁用单位']"
              :disabled="projectDetail.is_synchro_edc"
              @click="enableClick(scope.row)"
              >启用</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--创建单位-->
    <el-dialog
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="resetForm"
    >
      <div slot="title" class="title">
        {{ this.unitId ? "编辑" : "新增" }}单位
      </div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="proInfo"
        label-width="100px"
      >
        <el-form-item label="单位名称：" prop="name" size="mini">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label="单位编号：" prop="code" size="mini">
          <el-input v-model="ruleForm.code" />
        </el-form-item>
        <el-form-item label="单位类型：" prop="style" size="mini">
          <el-select
            v-model="ruleForm.style"
            placeholder="请选择活动区域"
            style="width: 100%"
            @change="changeType"
          >
            <el-option
              v-for="(item, index) in list"
              :key="index"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.style == '研究中心'"
          label="主要研究者"
          prop="main_researchers"
          size="mini"
        >
          <el-input
            v-model="ruleForm.main_researchers"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          :loading="is_loading"
          type="primary"
          @click="addOrEdit('ruleForm')"
          v-preventReClick
          >确 定</el-button
        >
        <el-button size="mini" @click="resetForm">取 消</el-button>
      </span>
    </el-dialog>
    <!--单位导入-->
    <importUnit
      :dialog-visible.sync="dialogVisible"
      :data-obj="leftdata"
      @dialogHide="dialogHanderHide"
    />
  </div>
</template>

<script>
import {
  getUnit,
  addUnit,
  detailUnit,
  editUnit,
  delUnit,
  enable,
  unitAll,
} from "@/api/company";
import { getProjectId } from "@/utils/auth";
import importUnit from "./component/importUnit";
export default {
  name: "Company",
  components: {
    importUnit,
  },
  data() {
    return {
      cellStyle: {
        textAlign: "center",
      },
      unitData: [],
      timer:"",
      key: "",
      currentPage: 1,
      pageSize: 10,
      is_loading: false,
      total: null,
      proId: "",
      centerDialogVisible: false,
      dialogVisible: false,
      ruleForm: {
        name: "",
        code: "",
        style: "",
        main_researchers: "",
      },
      rules: {
        name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入单位编号", trigger: "blur" }],
        style: [
          { required: true, message: "请选择单位类型", trigger: "change" },
        ],
      },
      list: [
        { text: "研究中心", value: "研究中心" },
        { text: "数据管理单位", value: "数据管理单位" },
        { text: "数据统计单位", value: "数据统计单位" },
        { text: "申办方", value: "申办方" },
        { text: "平台供应商", value: "平台供应商" },
        { text: "合同研究组织", value: "合同研究组织" },
        { text: "药物运输单位", value: "药物运输单位" },
        { text: "其他", value: "其他" },
      ],
      listStatus: [
        { text: "已启用", value: true },
        { text: "已禁用", value: false },
      ],
      unitId: "",
      leftdata: [],
      loading: false,
      style: null,
      enable: null,
      projectDetail: JSON.parse(sessionStorage.getItem("iwrs_project")),
    };
  },
  created() {
    this.proId = getProjectId();
    this.getUnit();
  },
  methods: {
    //防抖
    debounce(fn, time) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, time);
    },
    changeType(type) {
      // 修改单位类型
      if (type === "研究中心") {
        this.rules = {
          name: [
            { required: true, message: "请输入单位名称", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入单位编号", trigger: "blur" },
          ],
          style: [
            { required: true, message: "请选择单位类型", trigger: "change" },
          ],
          main_researchers: [
            {
              required: true,
              message: "请输入主要研究者",
              trigger: "blur",
            },
          ],
        };
      } else {
        //清空研究者
        this.ruleForm.main_researchers = "";
        this.rules = {
          name: [
            { required: true, message: "请输入单位名称", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入单位编号", trigger: "blur" },
          ],
          style: [
            { required: true, message: "请选择单位类型", trigger: "change" },
          ],
        };
      }
    },
    filterChange(filter) {
      console.info(filter);
      this.enable = filter.enable;
      this.style = filter.style;
      this.getUnit();
    },
    getUnit() {
      this.loading = true;
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
        style: this.style,
        enable: this.enable,
      };
      const res = this.$qs.stringify(params, { arrayFormat: "repeat" });
      getUnit(res)
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.unitData = res.data;
              this.total = res.total;
            } else {
              this.unitData = [];
            }
            this.getUnitList();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },

    dialogHanderHide() {
      this.dialogVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.code = "";
      this.ruleForm.style = "";
      this.ruleForm.main_researchers = "";
      this.centerDialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.getUnit();
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getUnit();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUnit();
    },
    getUnitList() {
      unitAll({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            this.leftdata = res.data.map((item) => {
              const obj = {};
              obj.name = item;
              return obj;
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    createUnit() {
      this.unitId = "";
      this.ruleForm.main_researchers = "";
      this.centerDialogVisible = true;
    },
    importClick() {
      this.dialogVisible = true;
    },
    // 创建项目
    addOrEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            project_id: this.proId,
            name: this.ruleForm.name,
            code: this.ruleForm.code,
            style: this.ruleForm.style,
            main_researchers: this.ruleForm.main_researchers,
          };
          if (!this.unitId) {
            this.addPro(params);
          } else {
            params.id = this.unitId;
            this.editPro(params);
          }
        } else {
          return false;
        }
      });
    },
    addPro(params) {
      this.is_loading = true;
      addUnit(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.centerDialogVisible = false;
            this.resetForm();
          } else {
            this.$message(res.msg);
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    editClick(row) {
      this.unitId = row.id;
      this.centerDialogVisible = true;
      const params = {
        id: row.id,
        project_id: this.proId,
      };
      detailUnit(params).then((res) => {
        if (res && res.code === 0) {
          if (res.data) {
            this.ruleForm.name = res.data.name;
            this.ruleForm.code = res.data.code;
            this.ruleForm.style = res.data.style;
            this.ruleForm.main_researchers = res.data.main_researchers;
            if (res.data.style === "研究中心") {
              this.rules["main_researchers"] = [
                {
                  required: true,
                  message: "请输入主要研究者",
                  trigger: "blur",
                },
              ];
              console.log(res.data);
            } else {
              this.rules["main_researchers"] = [];
            }
          }
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 禁用
    disableClick(row) {
      const params = {
        id: row.id,
        project_id: this.proId,
        enable: false,
      };
      enable(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getUnit();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 启用
    enableClick(row) {
      const params = {
        id: row.id,
        project_id: this.proId,
        enable: true,
      };
      enable(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getUnit();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    deleteClick(row) {
      this.$confirm(
        `是否确认删除单位 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>?`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            project_id: this.proId,
          };
          delUnit(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getUnit();
              } else {
                this.$message(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    editPro(params) {
      this.is_loading = true;
      editUnit(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.unitId = "";
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.resetForm();
          } else {
            this.$message(res.msg);
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getUnit, 500);
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.colm-left {
  line-height: 26px;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
</style>

